<template>
  <div>
    <Head title="Startseite" />

    <alert v-if="alert" :type="alert.type" :options="alert.options"><span v-html="alert.msg"></span></alert>

    <h1 class="h1">Hallo {{ welcomeName }}, <br>herzlich willkommen</h1>

    <div class="grid grid-cols-2 lg:grid-cols-4 gap-5">
      <a href="/themenbezogenes-lernen" class="card--img hover:bg-campusblue-500 hover:text-white group">
        <img class="max-h-36 w-full object-cover opacity-90 group-hover:opacity-100" src="/img/dashboard/dgvt-fuchs-themen-4.png" alt="">
        <div class="p-4 md:p-4 md:p-6">
          <h2 class="text-md lg:text-xl text-secondary-500 group-hover:text-white font-bold ">Themen</h2>
        </div>
      </a>

      <a href="/pruefungen" class="card--img hover:bg-campusblue-500 hover:text-white group">
        <img class="max-h-36 w-full object-cover opacity-90 group-hover:opacity-100" src="/img/dashboard/dgvt-fuchs-pruefungen-4.png" alt="">
        <div class="p-4 md:p-6">
          <h2 class="text-md lg:text-xl text-secondary-500 group-hover:text-white font-bold ">Alle Prüfungen</h2>
        </div>
      </a>

      <a href="/meine-pruefungen" class="card--img hover:bg-campusblue-500 hover:text-white group">
        <img class="max-h-36 w-full object-cover opacity-90 group-hover:opacity-100" src="/img/dashboard/dgvt-fuchs-fortsetzen-4.png" alt="">
        <div class="p-4 md:p-6">
          <h2 class="text-md lg:text-xl text-secondary-500 group-hover:text-white font-bold ">Prüfungen fortsetzen</h2>
        </div>
      </a>

      <a href="/meine-fehler" class="card--img hover:bg-campusblue-500 hover:text-white group">
        <img class="max-h-36 w-full object-cover opacity-90 group-hover:opacity-100" src="/img/dashboard/dgvt-fuchs-wiederholen-4.png" alt="">
        <div class="p-4 md:p-6">
          <h2 class="text-md lg:text-xl text-secondary-500 group-hover:text-white font-bold ">Fragen wiederholen</h2>
        </div>
      </a>

    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {

  components: {
    Head,
  },

  layout: Layout,

  props: {
    auth: Object,
    alert: {
      type: Object,
      required: false,
    },
  },

  computed: {
    welcomeName() {
      return ( this.auth.user.first_name ) ? this.auth.user.first_name : 'User'
    },
  }
}
</script>
